import React from "react";
import PropTypes from "prop-types";
import {
  Grid,
  Dialog,
  DialogActions,
  DialogTitle,
  TextField,
  Button,
} from "@material-ui/core/";
import UserStore from "../stores/UserStore";
import withSnack from "./withSnack";
import { TFAVerify, TFASetup, isTFAEnabled } from "./2FA";

class Verification extends React.Component {
constructor(props){
  super(props);
  this.state={
    isModalEmailOpen: false,
    isModal2FACaptureOpen: false,
    isModal2FASetupOpen: false,
    isTFAEnabled: isTFAEnabled(),
    isMainModalOpen: this.props.open
  };
}

componentDidMount() {
  if(this.props.can_create === 'true'){
    this.setState({ isMainModalOpen: false })

      if(this.state.isTFAEnabled === true && UserStore.info().verified === 'false'){
          this.setState({ isModal2FACaptureOpen: true })
      }

      if(this.state.isTFAEnabled === false){
          this.setState({ isModal2FASetupOpen: true })
      }
  }
  else{
      if(UserStore.info().verified === 'true'){
        this.setState({ isMainModalOpen: false })
      }
      else{
        this.setState({ isMainModalOpen: true })
      }
  }

  //this is for doesn't show the window for capture de token(dev and staging scopes)
  if(process.env.REACT_APP_DISABLED2FA === 'true'){
    this.onGoodCode()
  }
}

//email
openEmailModal = () => {
  this.setState({isModalEmailOpen: true});
}

closeEmailModal = (op) => {
  this.setState({ isModalEmailOpen: false });
  if(op === 'success'){
    this.setState({ isMainModalOpen: false });
    this.props.onClose(op);
  }
}

//2FA capture
closeModal2FACapture = (op) => {
  this.setState({ isModal2FACaptureOpen: false });
};

openModal2FACapture = () => {
  this.setState({
    isModal2FACaptureOpen: true
  });
}

//2FA setup
closeModal2FASetup = () => {
  this.setState({
    isModal2FASetupOpen: false
  });
};

openModal2FASetup = () => {
  this.setState({
    isModal2FASetupOpen: true
  });
}

onGoodCode = () => {
  UserStore.saveLocal("verified", true);
  this.setState({isModal2FACaptureOpen: false, isMainModalOpen: false });
  this.props.onClose('success');

  //I will show message if conditions apply
  if((navigator.platform.toUpperCase().indexOf('MAC') >= 0) && (navigator.userAgent.indexOf("Firefox") !== -1)  && (this.props.verified === 'false') && (((this.props.can_create === 'true')) || ((this.props.isDelegate === true)))){
    this.props.showPlatformMessage()
  }

};

onGoodCodeSetup = () => {
  UserStore.saveLocal("verified", true);
  this.setState({
    isModal2FASetupOpen: false,
    isTFAEnabled: true
  });
  this.props.onClose('success');
};

render() {
  const { can_create, user } = this.props;
  const { isModalEmailOpen, isModal2FACaptureOpen, isModal2FASetupOpen, isTFAEnabled, isMainModalOpen } = this.state;

  let optionEmail = (
    <Button color="primary" onClick={this.openEmailModal} className="button_modal_medium">
      utilizar Correo
    </Button>
  );

  if(can_create === 'true'){
    optionEmail = null;
  }

  let tfaOption = () => this.openModal2FASetup();

  if(isTFAEnabled === true){
    tfaOption = () => this.openModal2FACapture();
  }

  return (
    <div>
    <Dialog
      key={1}
      aria-labelledby="choose-account"
      open={isMainModalOpen}
      maxWidth="sm"
      fullWidth
      className="fix-modal">
      <DialogTitle>Verificación</DialogTitle>
        <Grid item xl={12} style={{padding:'0px 24px 0px 24px'}}>
          Es necesario realizar la verificación para continuar
        </Grid>
        <DialogActions className="button_modal">
          {optionEmail}
          <Button onClick={tfaOption} color="primary" className="button_modal_medium">
            utilizar código QR
          </Button>
        </DialogActions>
    </Dialog>
    <EmailModal
      open={isModalEmailOpen}
      close={this.closeEmailModal}
      user={user}/>
    <TFAVerify
      open={isModal2FACaptureOpen}
      onClose={this.closeModal2FACapture}
      onContinue={() => this.onGoodCode()}
      can_create={can_create}/>
    <TFASetup
      onClose={this.closeModal2FASetup}
      open={isModal2FASetupOpen}
      onContinue={() => this.onGoodCodeSetup()}
      setupLogin={true}
      can_create={can_create}/>
  </div>
  );
}
}

class EmailModal extends React.Component {
constructor(props){
  super(props);
  this.state={
    sentCode: false,
    code: "",
  };
}

sendEmail = e => {
  this.setState({ sentCode: true })
  e.preventDefault();
  const { user } = this.props;

  UserStore.send_email_verification(user).then(r => {

    if (r.data.status === 'ok') {
      this.props.snack("Correo enviado con éxito", 'success');
    }
    else {
      this.props.snack("Ocurrió un error", 'warning');
    }
  });
}

cancel = () =>{
  this.setState({ sentCode: false, code: "" })
  this.props.close('cancel');
}

onCodeChange = e => {
  this.setState({ code: e.target.value });
};

//verify code
verifyCode = e => {
  e.preventDefault();
  const { user } = this.props;
  const { code } = this.state;
  UserStore.send_code_to_verify(user, code).then(r => {
    if (typeof r.data.success === 'string') {
      this.props.snack("Verificación exitosa", 'success');
      UserStore.saveLocal("verified", true);
      this.props.close('success');
    }
    else {
      this.props.snack("Verificación fallida", 'warning');
    }
  });
}

render() {
  const { open } = this.props;
  const { sentCode, code } = this.state;
  let instructions = 'Presione enviar correo';
  let action = 'Enviar correo';
  let buttonVerifyCode = null;

  let inputCode = null;
  if(sentCode){
    action = 'Reenviar correo';
    instructions = 'Si no recibió el correo presione reenviar correo';
    buttonVerifyCode = (
      <Button color="primary" onClick={this.verifyCode} variant="contained" disabled={code.length > 0? false : true }>
        validar código
      </Button>
    );

    inputCode = (
      <TextField
        className="inputCenter"
        autoFocus
        label="Ingrese el código"
        variant="outlined"
        type="text"
        value={code}
        style={{ minWidth: '270px' }}
        onChange={this.onCodeChange}
        inputProps={{
          maxLength: 30
        }}
      />
    );
  }

  let buttonSendEmail = (
    <Button color="primary" onClick={this.sendEmail} variant="contained">
      {action}
    </Button>
  );

  return (
    <Dialog
      key={2}
      aria-labelledby="choose-account"
      open={open}
      maxWidth="sm"
      fullWidth
      className="fix-modal">
      <DialogTitle>Verificación</DialogTitle>
        <Grid item xl={12} style={{padding:'0px 24px 0px 24px'}}>
          {instructions}
          <form onSubmit={this.check_code} style={{ marginTop:20 }}>
            <Grid
              container
              spacing={8}
              alignItems="center"
              justify="center"
            >
              <Grid item sm={12}>
                {inputCode}
              </Grid>
            </Grid>
          </form>
        </Grid>
        <DialogActions className="button_modal">
          {buttonVerifyCode}
          {buttonSendEmail}
          <Button color="primary" onClick={this.cancel} className="button_modal_medium">
            cancelar
          </Button>
        </DialogActions>
    </Dialog>
  );
}
}

Verification.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

EmailModal.propTypes = {
  open: PropTypes.bool.isRequired
};

EmailModal = withSnack(EmailModal)

export default Verification



// WEBPACK FOOTER //
// ./src/components/VerificationModal.js